module.exports = __webpack_public_path__ + "static/media/Link_Button@3x.81885819.png";